import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { clearfixStyles } from "@store/theme/common/mixins";
import { formButtonSpacingStyles } from "@store/theme/common/props/form";
import { mediaOptions } from "@store/utilities/breakpointMediaQueries";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import React from "react";
import { css } from "styled-components";

export interface StoreFormActionsStyles {
    container?: InjectableCss;
    wrapper?: InjectableCss;
    item?: InjectableCss;
}

const styles: StoreFormActionsStyles = {
    container: {
        css: css`
            width: 100%;
            ${formButtonSpacingStyles()}
            ${clearfixStyles()}
        `,
    },
    wrapper: {
        css: css`
            display: flex;
            flex-flow: row wrap;
            margin: -8px 0 0 -8px;
        `,
    },
    item: {
        css: css`
            margin: 8px 0 0 8px;
            ${({ theme }) =>
                breakpointValuesMediaQueries(
                    theme,
                    [{ values: ["100%", "auto"], properties: ["width"] }],
                    mediaOptions.min,
                )}

            a, button {
                width: 100%;
            }
        `,
    },
};

export const formActionsStyles = styles;

const StoreFormActions: React.FC = ({ children }) => {
    if (!children) {
        return null;
    }

    return (
        <StyledWrapper {...styles.container}>
            <StyledWrapper {...styles.wrapper}>
                {React.Children.map(children, (button: any) =>
                    button ? <StyledWrapper {...styles.item}>{button}</StyledWrapper> : null,
                )}
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default StoreFormActions;
